import React from 'react';
import Reflux from 'reflux';
import AppStore from '../AppStore';
import SearchStore from '../stores/SearchStore';
import AppActions from '../AppActions';
import TopList from './TopList';
import TopicList from './TopicList';
import RcIf, {RcElse} from 'rc-if';
import {Link} from 'react-router-dom';
import './NowTops.css';

class NowTops extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            trendingTopics: [],
            latestTopics: [],
            searchResult: {
                usertopics: [],
                globaltopics: []
            },
            page: props.page,
            autogeneratedTopics: []
        };
        this.stores = [AppStore, SearchStore];
    }
    componentWillReceiveProps (newProps) {
        if (newProps.page && newProps.page !== this.props.page) {
            this.setState({page: newProps.page});
            AppActions.getMoreLatestTopics(newProps.page);
            return;
        }
        if (!newProps.page && this.props.page !== 1) {
            this.setState({page: 1});
            AppActions.getMoreLatestTopics(1);
        }
    }
    loadMoreFollowedTopics = () => {
        AppActions.getFollowedTopics();
    }
    componentDidMount () {
        AppActions.getTrendingTopics();
        AppActions.getLatestTopics(this.props.page);
        AppActions.getAutogeneratedTopics();
        if (this.state.userLogged) {
            AppActions.getFollowedTopics();
        }
    }

    render () {
        let trendingTitles = [];
        if (this.state.trendingTopics) {
            trendingTitles = this.state.trendingTopics.map((topic) => {
                return topic.title;
            });
        }
        return <div className='col s12 space-tops'>
          <RcIf if={!this.state.loadingTrendingTopics}>
            <div>
              <div className='container-gral'>
                <div className='row'>
                  <div className='col s12'>
                    <h4 className='title-home'><span>Populares</span></h4>
                  </div>
                  <TopicList topics={trendingTitles} noResultsMessage='No se encontraron Topics Destacados' />
                </div>
                <div className='row'>
                  <div className='col s12'>
                    <h4 className='title-home'><span>En este momento</span></h4>
                  </div>
                  <TopList tops={this.state.latestTopics} />
                  <div className='row center-align'>
                    <Link className='btn-flat waves-effect waves-light plus-btn' to={`/now/${Number(this.props.page) + 1}`}>
                      <img src='/images/icons/plus.svg' />
                    </Link>
                  </div>
                </div>
                <RcIf if={this.state.userLogged && this.state.followedTopics.length > 0}>
                  <div className='row'>
                    <div className='col s12'>
                      <h4 className='title-home'><span>Tops seguidos</span></h4>
                    </div>
                    <TopList tops={this.state.followedTopics} />
                    <div className='row center-align'>
                      <a className='btn-flat waves-effect waves-light plus-btn' onClick={this.loadMoreFollowedTopics}>
                        <img src='/images/icons/plus.svg' />
                      </a>
                    </div>
                  </div>
                </RcIf>
              </div>
            </div>
            <RcElse>
              <img src='/images/loaders/loaderInit.svg' />
            </RcElse>
          </RcIf>
        </div>;
    }
}

export default NowTops;



// WEBPACK FOOTER //
// ./src/sections/NowTops.js